import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { AbstractFeatureEntityStore } from '@y42/feature';
import { VisualizationThemeGitFactoryService } from './visualization-theme-git-factory.service';
import { VisualizationThemeState } from './visualization-theme.model';

const initialState: VisualizationThemeState = {
  loading: true,
  last_used: {},
  starred: {},
  ui: {
    activeSection: 'theme-picker',
    localThemeChanges: {},
  },
  active: null,
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'visualization-theme', idKey: '$path' })
export class VisualizationThemeStore extends AbstractFeatureEntityStore<VisualizationThemeState> {
  constructor(public readonly gitFactory: VisualizationThemeGitFactoryService) {
    super({ name: 'Visualization-Theme', gitFactory, initialState });
  }
}
